<template>
  <div class='logout'>
    <main>
      <div class="title">将“{{ userInfo.xingming }}”所绑定的账号注销</div>
      <div class="hint">温馨提示：</div>
      <div class="hint">注销账号为不可逆操作，请您谨慎确认。一旦完成注销，以下信息将被清空且无法找回：</div>
      <div class="log-info">
        <div>1、身份信息、绑定的账户信息；</div>
        <div>2、已完成的交易、订单、服务记录等；</div>
        <div>3、个人资料及历史消息。</div>
      </div>
      <div class="warn">
        您的账号注销后，与该账号关联的所有服务将被暂停，用户数据将按法律法规要求进行处理（部分数据可能因监管需要做匿名化保留，不再关联至您个人）。
      </div>
      <div class="warn">
        处理时限说明：
      </div>
      <div class="warn">
        如您在注销过程中遇到问题，或对个人信息处理有任何疑问，请联系我们：<span style="color: #2AA9B5;font-weight: bold;">0731-82229030</span>
      </div>
      <div class="warn">
        我方接收您的申请后，将在10 个工作日内完成全流程核查与注销处置；处理完毕后，该账号将永久无法登录，账号内全部数据亦不可恢复，请您知悉。
      </div>
    </main>
    <div class="checked-view">
      <p v-if="checked" class="checked" @click="checked = !checked"><i class="el-icon-check"></i></p>
      <p v-else @click="checked = !checked"></p>
      <span @click="checked = !checked">我已阅读并理解上述内容</span>
    </div>
    <div class="btn" :class="{ disabled: !checked }" @click="handleOut">确认注销</div>
  </div>
</template>

<script>
import Api from '@/api/my'
import HApi from '@/api/home.js'
export default {
  data () {
    return {
      userInfo: {},
      checked: false
    }
  },
  mounted () {
    this.userInfo = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : {};
  },
  methods: {
    handleOut () {
      if (!this.checked) {
        this.$message({
          message: '请先阅读上述文档!',
          type: 'warning'
        })
        return;
      }
      Api.logoutFun({}).then(res => {
        if (res.errno == 0) {
          this.$message({
            message: '注销成功!',
            type: 'success',
            onClose: () => {
              HApi.loginOut({})
              localStorage.setItem("userInfo", '')
              localStorage.setItem("token", '')
              localStorage.setItem("year", '')
              this.$store.commit('setToken', '')
              this.token = localStorage.getItem('token') || ''
              window.location.href = window.location.protocol + '//' + window.location.host
            }
          });
        } else {
          this.$message({
            message: res.message || '注销失败!',
            type: 'error',
          })
        }
      })
    },
  }
}
</script>

<style lang='less' scoped>
.logout {
  padding: 30px;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #fff;

  >main {
    flex: 1;
  }

  .title {
    padding: 20px 0;
    border-bottom: 1px solid #f3f3f3;
    font-size: 26px;
    font-weight: bold;
  }

  .hint {
    color: #2AA9B5;
    font-size: 24px;
    margin-top: 10px;
  }

  .log-info {
    margin-top: 20px;
    background-color: #f0f0f0;
    padding: 20px;
    border-radius: 5px;
    color: #000;

    >div {
      font-size: 22px;
      margin-top: 10px;
    }
  }

  .warn {
    margin-top: 25px;
    font-size: 22px;
    color: #000;

    >span {
      font-size: 22px;
    }
  }

  .checked-view {
    font-size: 22px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;

    >p {
      border: 1px solid #999999;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      font-size: 26px;
      margin-right: 5px;
      cursor: pointer;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;

      i {
        font-size: 12px;
      }
    }

    > p.checked {
      border-color: #2aa9b5;
      background-color: #2aa9b5;
      color: #ffffff;
    }

    >span {
      font-size: 22px;
      white-space: nowrap;
      margin-left: 10px;
    }
  }

  .btn {
    width: 420px;
    height: 40px;
    line-height: 40px;
    border-radius: 40px;
    text-align: center;
    background-color: #2AA9B5;
    color: #FFFFFF;
    font-size: 22px;
    letter-spacing: 10px;
    margin: 10px auto 0;
    cursor: pointer;
  }

  .disabled {
    background-color: #888;
  }
}
</style>